import { Flex, FormNumberInput } from '@shared/components';

export default function ScorePerQuestionFormField() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
        gap: theme.spacing(1),
      })}
    >
      <FormNumberInput
        label='คะแนนต่อข้อ'
        name='scorePerQuestion'
        placeholder='ระบุคะแนนต่อข้อ'
        sx={{ maxWidth: '180px' }}
      />
    </Flex>
  );
}
